export const CONVENIENT = [
  {
    title: 'Подготовка объявления',
    good: 'Фото и текст от экспертов',
    bad: 'По советам из интернета',
  },
  {
    title: 'Реклама объявления в топе',
    good: 'Бесплатно',
    bad: 'С доплатой',
  },
  {
    title: 'Показ квартиры',
    good: 'Проведём в любое время',
    bad: 'В ваше свободное время',
  },
  {
    title: 'Сохранность имущества',
    good: 'Составим опись и оформим страховку',
    bad: 'Стараетесь защититься депозитом',
  },
  {
    title: 'Проверка арендатора',
    good: 'Проверим документы, долги и нарушения',
    bad: 'Надеетесь на интуицию',
  },
  {
    title: 'Гарантия ежемесячной оплаты',
    good: 'Застрахуем платежи по аренде',
    bad: 'Верите в честность жильца',
  },
  {
    title: 'Договор и личный кабинет',
    good: 'Проверен юристами и защищает ваши интересы',
    bad: 'Шаблон из интернета, не учитывающий всех аспектов',
  },
  {
    title: 'Сдать квартиру удаленно',
    good: 'Передайте ключи, всё сделаем за вас',
    bad: 'Выезжаете на каждый показ и тратите своё время',
  },
];
